import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

export interface ExternalAccountsResponse {
  ref: string;
  accountId: string;
}

const getExternalAccounts = async (
  token: string,
): Promise<ExternalAccountsResponse[]> => {
  try {
    let url = `${getBaseUrl(Microservice.PAYMENT)}/payment/ledger/getExternalAccounts`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default getExternalAccounts;
